module.exports = __webpack_public_path__ + "img/opdrachten-icon.f867154.png";